export default __webpack_public_path__ + "static/media/O2.0d50591e.png";